import React from "react";
import { motion } from "framer-motion";
import { Target } from "lucide-react";

export default function GoalsSection({ content }) {
  const goals = content.goals || [];
  return (
    <section id="goals" data-testid="goals-section" className="py-20 md:py-28 bg-[#120908] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(circle_at_80%_20%,#F0E8DB,transparent_45%)]" />
      <div className="max-w-6xl mx-auto px-4 sm:px-8 relative">
        <div className="text-center mb-14">
          <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">OUR GOALS</div>
          <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl">{content.titles.goals}</h2>
          {content.goals_intro && <p className="text-[#A89A88] mt-4 max-w-2xl mx-auto">{content.goals_intro}</p>}
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#F0E8DB] to-transparent mx-auto mt-6" />
        </div>
        <ol className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {goals.map((g, i) => (
            <motion.li
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 2) * 0.08 }}
              data-testid={`goal-item-${i}`}
              className="theater-card rounded-2xl p-5 flex gap-4 items-start hover:border-[#F0E8DB]/50 transition-colors"
            >
              <div className="w-11 h-11 shrink-0 rounded-xl bg-[#7A2E2A]/40 border border-[#F0E8DB]/40 flex items-center justify-center font-serif-en font-bold text-[#F0E8DB] text-lg">
                {String(i + 1).padStart(2, "0")}
              </div>
              <p className="text-[#C5B8A8] text-sm sm:text-base leading-loose pt-1">{g}</p>
            </motion.li>
          ))}
        </ol>
        {goals.length === 0 && (
          <div className="text-center text-[#A89A88] flex items-center justify-center gap-2"><Target size={16} /> لم تُضف الأهداف بعد.</div>
        )}
      </div>
    </section>
  );
}
